// src/app/redux/sagas/sallesSaga.js

import { call, put } from "redux-saga/effects";
import Swal from "sweetalert2";

import {
    FETCH_SALLES_REQUEST,
    fetchSallesSuccess,
    fetchSallesFail,

    createSalleSuccess,
    createSalleFail,

    updateSalleSuccess,
    updateSalleFail,

    deleteSalleSuccess,
    deleteSalleFail,

    setSallesLoading,
} from "../actions/sallesActions";

import { API_BASE_URL, getRequest, postRequest, putRequest, deleteRequest } from "../../../api";

const getUid = () => sessionStorage.getItem("uid");
const getToken = () => sessionStorage.getItem("token");

export function* fetchSallesSaga() {
    const url = `${API_BASE_URL}/api/salles`;
    const uid = getUid();
    const token = getToken();

    yield put(setSallesLoading(true));
    try {
        const resp = yield call(getRequest, { url, uid, token });
        yield put(fetchSallesSuccess(resp.data));
    } catch (e) {
        yield put(fetchSallesFail(e.response?.data?.message || e.message));
    } finally {
        yield put(setSallesLoading(false));
    }
}

export function* createSalleSaga(action) {
    const url = `${API_BASE_URL}/api/salles`;
    const uid = getUid();
    const token = getToken();

    yield put(setSallesLoading(true));
    try {
        const resp = yield call(postRequest, {
            url,
            data: action.payload,
            uid,
            token,
        });

        yield put(createSalleSuccess(resp.data));

        yield call([Swal, Swal.fire], {
            icon: "success",
            text: "Salle ajoutée",
            timer: 1400,
            showConfirmButton: false,
        });

        // refresh list
        yield put({ type: FETCH_SALLES_REQUEST });
    } catch (e) {
        const msg = e.response?.data?.message || "Erreur ajout salle";
        yield put(createSalleFail(msg));
        yield call([Swal, Swal.fire], { icon: "error", text: msg, timer: 2200, showConfirmButton: false });
    } finally {
        yield put(setSallesLoading(false));
    }
}

export function* updateSalleSaga(action) {
    const { id, payload } = action.payload;
    const url = `${API_BASE_URL}/api/salles/${id}`;
    const uid = getUid();
    const token = getToken();

    yield put(setSallesLoading(true));
    try {
        const resp = yield call(putRequest, {
            url,
            data: payload,
            uid,
            token,
        });

        yield put(updateSalleSuccess(resp.data));

        yield call([Swal, Swal.fire], {
            icon: "success",
            text: "Salle modifiée",
            timer: 1400,
            showConfirmButton: false,
        });

        yield put({ type: FETCH_SALLES_REQUEST });
    } catch (e) {
        const msg = e.response?.data?.message || "Erreur modification salle";
        yield put(updateSalleFail(msg));
        yield call([Swal, Swal.fire], { icon: "error", text: msg, timer: 2200, showConfirmButton: false });
    } finally {
        yield put(setSallesLoading(false));
    }
}

export function* deleteSalleSaga(action) {
    const { id } = action.payload;
    const url = `${API_BASE_URL}/api/salles/${id}`;
    const uid = getUid();
    const token = getToken();

    yield put(setSallesLoading(true));
    try {
        yield call(deleteRequest, { url, uid, token });
        yield put(deleteSalleSuccess(id));

        yield call([Swal, Swal.fire], {
            icon: "success",
            text: "Salle supprimée",
            timer: 1400,
            showConfirmButton: false,
        });
    } catch (e) {
        const msg = e.response?.data?.message || "Erreur suppression salle";
        yield put(deleteSalleFail(msg));
        yield call([Swal, Swal.fire], { icon: "error", text: msg, timer: 2200, showConfirmButton: false });
    } finally {
        yield put(setSallesLoading(false));
    }
}
